import React, { useState } from 'react';
import { COPYRIGHT } from 'js/constants/App';
import { staticImageAssets } from 'js/constants/Paths';
import { useData } from 'js/context/DataContext';

// import tracking
import { track, TRACKING_EVENTS } from 'js/utils/tracking';

// import svg
import SvgMailIcon from 'js/components/svg/Svg.mail-icon';
import SvgCloseIcon from 'js/components/svg/Svg.close-icon';
import SvgArrowDown from 'js/components/svg/Svg.arrow-down';
import SvgFacebook from 'js/components/svg/social/Svg.facebook';
import SvgInstagram from 'js/components/svg/social/Svg.instagram';
import SvgPinterest from 'js/components/svg/social/Svg.pinterest';
import SvgTiktok from 'js/components/svg/social/Svg.tiktok';
import SvgYoutube from 'js/components/svg/social/Svg.youtube';
import SvgSpotify from 'js/components/svg/social/Svg.spotify';

const SOCIAL_LINKS = [
  {
    type: 'spotify',
    url: 'https://open.spotify.com/artist/6ca3AFdIIgaP4ZIW8J6zXu',
    icon: <SvgSpotify />,
  },
  {
    type: 'youtube',
    url: 'https://www.youtube.com/c/BlueyOfficialChannel',
    icon: <SvgYoutube />,
  },
  {
    type: 'facebook',
    url: 'https://www.facebook.com/OfficialBlueyTV/',
    icon: <SvgFacebook />,
  },
  {
    type: 'instagram',
    url: 'https://www.instagram.com/officialbluey/',
    icon: <SvgInstagram />,
  },
  {
    type: 'tiktok',
    url: 'https://www.tiktok.com/@bluey',
    icon: <SvgTiktok />,
  },
  {
    type: 'pinterest',
    url: 'https://www.pinterest.co.uk/OfficialBlueyTV/',
    icon: <SvgPinterest />,
  },
];

const Footer = () => {
  const { footer_links = [], settings } = useData();
  const [visible, setVisisble] = useState(false);

  const clickHandler = () => {
    setVisisble(!visible);

    if (!visible) {
      setTimeout(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth',
        });
      }, 100);
    }
  };

  const onClickTrack = (name, url) => {
    track(TRACKING_EVENTS.CLICK_NAVIGATION_FOOTER.id, {
      item_name: name,
      item_link: url,
    });
  };

  return (
    <div style={{ position: 'relative' }}>
      <button className={'footer__button' + (visible ? ' footer__button--active' : '')} onClick={clickHandler}>
        {!visible ? (
          <div className="footer__button__label">
            <span>{'© Judo'}</span>
            <SvgArrowDown />
          </div>
        ) : (
          <SvgCloseIcon />
        )}
      </button>
      <footer className="footer" style={{ display: visible ? 'flex' : 'none' }}>
        <div className="footer__inner">
          <div className="footer__brand" aria-label="Bluey Movie Logo">
            <img src={staticImageAssets('images/static/footer_logo.png')} />
          </div>

          <div className="footer__right-container">
            <div className="footer__actions">
              <div className="footer__social-links" aria-label="Social links">
                {SOCIAL_LINKS.map((item, index) => (
                  <button
                    className="footer__social-link"
                    type="button"
                    aria-label={`Social link ${item.type}`}
                    key={`social-link--${item.type}--${index}`}
                  >
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => {
                        onClickTrack(item.type, item.url);
                      }}
                    >
                      {item.icon}
                    </a>
                  </button>
                ))}
              </div>

              <button className="footer__subscribe" type="button">
                <a href={settings?.subscribe_link?.subscribe_url || ''} target="_blank" rel="noreferrer">
                  <span className="footer__subscribe-label">Subscribe</span>
                  <SvgMailIcon />
                </a>
              </button>
            </div>
            <div className="footer__legal">
              <p className="footer__copyright">{COPYRIGHT}</p>

              <nav className="footer__legal-nav" aria-label="Footer legal links">
                {footer_links.map((link, index) => (
                  <a
                    className="footer__legal-link"
                    href={link.url}
                    key={`legal-link--${index}`}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => {
                      onClickTrack(link.name, link.url);
                    }}
                  >
                    {link.name}
                  </a>
                ))}
              </nav>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
